export default __webpack_public_path__ + "static/media/logo.f48b0867.svg";